import { Attachment, FeedbackDetails, domain } from "@relode/core";
import { CandidateInterview, JobCandidateStatus } from "@relode/core/domain";
import {
    JobManagerContact,
    CandidateActions,
    CandidateAdditionalInfo,
    CandidateAvailability,
    CandidateHighlights,
    CandidateHiredDetails,
    CandidateJobDetails,
} from ".";

export class CandidateDetails {
    status: JobCandidateStatus;
    highlights: CandidateHighlights;
    additionalInfo: CandidateAdditionalInfo;
    formattedResume: Attachment;
    availability: CandidateAvailability;
    job: CandidateJobDetails;
    jobManager: JobManagerContact;
    redirectToPrivate: boolean;
    showGiveFeedback: boolean;
    candidateConcurrencyToken: string;
    feedbackDetails: FeedbackDetails;
    hiredDetails: CandidateHiredDetails;
    canViewCandidateActions: boolean;
    actions: CandidateActions;
    pastInterviews: CandidateInterview[];
    upcomingInterviews: CandidateInterview[];
    qualifications: domain.LeadJobQualifications;
    canOffer: boolean;
    canReject: boolean;
    canEditHire: boolean;
    canAddInterview: boolean;
    isCandidateRejectPromptRequired: boolean;
    hasMobileActions: boolean;
}
